import { Text, makeStyles } from '@rneui/themed'
import React from 'react'
import { View } from 'react-native'

interface Props {
  value: number | string | undefined
  position?: 'absolute' | 'relative'
  xOffset?: number
  yOffset?: number
}

export function Badge({
  value,
  position = 'relative',
  xOffset = 0,
  yOffset = 0,
}: Props) {
  const styles = useStyles(position)

  if (value !== undefined) {
    const showBadgeDot = value === ''
    return typeof value === 'number' && value <= 0 ? null : (
      <View
        style={[
          styles.badgeCounter,
          { bottom: yOffset, left: xOffset },
          showBadgeDot && styles.badgeDot,
        ]}
      >
        <Text style={styles.badgeCounterText}>{value}</Text>
      </View>
    )
  }

  return <></>
}
const useStyles = makeStyles((theme, position: 'absolute' | 'relative') => ({
  badgeCounter: {
    position: position,
    paddingHorizontal: 2,
    justifyContent: 'center',
    backgroundColor: 'pink',
    marginLeft: 5,
    borderRadius: 14,
  },
  badgeCounterText: {
    marginHorizontal: 5,
    textAlignVertical: 'center',
  },
  badgeDot: { width: 15, height: 15, borderRadius: 10 },
}))
